import React, { useState, useEffect, useCallback } from 'react';
import { motion } from 'framer-motion';
import { useScore } from '../../context/ScoreProvider';
import cake2 from '../../assets/cake 2.png';
import cake5 from '../../assets/cake 5.png';
import hero from '../../assets/hero.png';
import kulbabka from '../../assets/kulbabka.svg';
import lapun from '../../assets/lapun.svg';
import kruglik from '../../assets/kruglik.svg';
import fishik from '../../assets/fishik.svg';
import bigCake from '../../assets/big-cake.png';
import cipaStory from '../../assets/cipa-story.svg';
import numberCake from '../../assets/number-cake.png';
import '../../styles/FractionStoryScreen.css';

const slideUpVariants = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: 'easeOut' }
  }
};

const slideFromLeft = {
  hidden: { opacity: 0, x: -80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

const slideFromRight = {
  hidden: { opacity: 0, x: 80 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: 'easeOut' }
  }
};

export default function FractionStoryScreen({
  question,
  image,
  images,
  columnDirection,
  options,
  feedback,
  onCheckStateChange,
  screenId,
  screenScore
}) {
  const { submitAnswer } = useScore();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);

  const handleSelect = (option, index) => {
    if (isChecked) return;
    setSelectedOption({ ...option, index });
  };

  const handleCheck = useCallback(() => {
    if (!selectedOption) return;

    setIsChecked(true);
    if (screenScore != null) {
      submitAnswer(screenId, screenScore, selectedOption.correct);
    }
    onCheckStateChange?.({
      checked: true,
      correct: selectedOption.correct,
    });
  }, [onCheckStateChange, screenId, screenScore, selectedOption, submitAnswer]);

  useEffect(() => {
    onCheckStateChange?.({
      checked: isChecked,
      canCheck: !!selectedOption,
      onCheck: handleCheck,
    });
  }, [selectedOption, isChecked, handleCheck, onCheckStateChange]);

  const hasLinkedImages = images && Array.isArray(images) && images.length > 0;

  const getImageState = (imageIndex) => {
    if (!isChecked || !selectedOption) return 'default';
    if (images[imageIndex]?.linkedTo === selectedOption.index) {
      return selectedOption.correct ? 'correct' : 'incorrect';
    }
    return 'default';
  };

  const showFeedback =
    isChecked &&
    selectedOption &&
    ((selectedOption.correct && feedback?.correct) ||
     (!selectedOption.correct && feedback?.incorrect));

  const feedbackClass = selectedOption?.correct
    ? 'quiz-feedback-correct'
    : 'quiz-feedback-incorrect';

  const feedbackContent = selectedOption?.correct
    ? feedback?.correct
    : feedback?.incorrect;

  return (
    <div className="fraction-story-screen quiz-screen">
      <div className="fraction-story quiz-card">
        <div className="fraction-story-container">
          <p className="fraction-story-title paper-note">День<br/>народження<br/>Ципи</p>
          <img className="fraction-story-cake-2" src={cake2} alt="" />
          <img className="fraction-story-cake-5" src={cake5} alt="" />
          <p className="fraction-story-go-down">Гортай униз, щоб дізнатися історію дня народження</p>
          <svg className="fraction-story-go-down-btn" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_95_1660" style={{maskType:"alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="40" height="40">
                <rect width="40" height="40" fill="#D9D9D9"/>
              </mask>
              <g mask="url(#mask0_95_1660)">
                <path d="M19.8492 25.9062L25.6408 20.1253L24.1825 18.667L20.8963 21.9532V14.0782H18.7863V21.9532L15.5 18.667L14.0417 20.1253L19.8492 25.9062ZM19.8363 35.8337C17.6576 35.8337 15.6067 35.4181 13.6833 34.587C11.76 33.7559 10.081 32.6234 8.64625 31.1895C7.21181 29.7553 6.07875 28.077 5.24708 26.1545C4.41569 24.232 4 22.1816 4 20.0032C4 17.8132 4.41556 15.7548 5.24667 13.8278C6.07778 11.9009 7.21028 10.2248 8.64417 8.79949C10.0783 7.37421 11.7567 6.24574 13.6792 5.41408C15.6017 4.58269 17.6521 4.16699 19.8304 4.16699C22.0204 4.16699 24.0789 4.58255 26.0058 5.41366C27.9328 6.24477 29.6089 7.37269 31.0342 8.79741C32.4594 10.2221 33.5879 11.8975 34.4196 13.8237C35.251 15.7498 35.6667 17.8077 35.6667 19.9974C35.6667 22.176 35.2511 24.227 34.42 26.1503C33.5889 28.0737 32.461 29.7527 31.0363 31.1874C29.6115 32.6219 27.9361 33.7549 26.01 34.5866C24.0839 35.418 22.026 35.8337 19.8363 35.8337ZM19.8333 33.7395C23.6608 33.7395 26.9076 32.4037 29.5738 29.732C32.2396 27.0603 33.5725 23.8164 33.5725 20.0003C33.5725 16.1728 32.2396 12.926 29.5738 10.2599C26.9076 7.59407 23.6608 6.26116 19.8333 6.26116C16.0172 6.26116 12.7733 7.59407 10.1017 10.2599C7.43 12.926 6.09417 16.1728 6.09417 20.0003C6.09417 23.8164 7.43 27.0603 10.1017 29.732C12.7733 32.4037 16.0172 33.7395 19.8333 33.7395Z" fill="#1E1E1E"/>
              </g>
            </svg>
        </div>

        <div className="fraction-story-pink-bg">
          <img className="fraction-story-hero" src={hero} alt="" />
          <div className="fraction-story-pink-rectangle">
            <motion.p
              className="fraction-story-pink-rec-text"
              variants={slideUpVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.4 }}
            >
              На день народження до Ципи завітали четверо друзів і подруг: Кульбабка, Лапун, Круглик, Фішик
            </motion.p>

            <div className="fraction-story-heroes">
              {[
                { img: kulbabka, name: 'Кульбабка' },
                { name: 'Лапун', img: lapun },
                { img: kruglik, name: 'Круглик' },
                { name: 'Фішик', img: fishik }
              ].map((item, index) => (
                <motion.div
                  key={index}
                  className="fraction-story-hero"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.3 }}
                  variants={index % 2 === 0 ? slideFromLeft : slideFromRight}
                >
                  {index % 2 === 0 ? (
                    <>
                      <img src={item.img} alt="" />
                      <p>{item.name}</p>
                    </>
                  ) : (
                    <>
                      <p>{item.name}</p>
                      <img src={item.img} alt="" />
                    </>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </div>

        <div className="fraction-story-white-rectangle">
          <img className="fraction-story-big-cake" src={bigCake} alt="" />
          <motion.p
            className="fraction-story-white-rec-text"
            variants={slideUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            Ципа люб’язно запропонував їм торт 
          </motion.p>
          <img className="fraction-cipa-story" src={cipaStory} alt="" />
          <img
            style={{ marginLeft: '30px' }}
            className="fraction-story-arrow-1"
            src="data:image/svg+xml,%3Csvg width='51' height='76' viewBox='0 0 51 76' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14.6138 71.1695L32.3002 70.6841L31.8141 53' stroke='%231E1E1E' strokeWidth='4' strokeMiterlimit='10'/%3E%3Cpath d='M23.1586 1.24206C23.1586 1.24206 -6.36566 38.375 32.0071 70.1084' stroke='%231E1E1E' strokeWidth='4' strokeMiterlimit='10'/%3E%3C/svg%3E%0A"
            alt=""
          />
        </div>

        <div className="fraction-story-blue-rectangle">
          <p className="fraction-story-blue-rec-text">
            Ципа розділив торт на рівні частини
          </p>
        </div>

        <div className="fraction-story-pink-rectangle-2">
          <img src={numberCake} className="fraction-story-number-cake" alt="" />
          <motion.p
            className="fraction-story-white-rec-text"
            variants={slideUpVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.4 }}
          >
            Увага! Маю запитання
          </motion.p>
          <svg className="fraction-story-arrow-2" width="51" height="76" viewBox="0 0 51 76" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6138 71.1695L32.3002 70.6841L31.8141 53" stroke="#1E1E1E" strokeWidth="4" strokeMiterlimit="10"/>
            <path d="M23.1586 1.24206C23.1586 1.24206 -6.36566 38.375 32.0071 70.1084" stroke="#1E1E1E" strokeWidth="4" strokeMiterlimit="10"/>
          </svg>
        </div>

        <div className="fraction-story-question">
          {question && (
            <div
              className={`quiz-question font-${question?.fontSize ?? "md"} text-${question?.textAlign ?? "left"}`}
              dangerouslySetInnerHTML={{ __html: question.value }}
            />
          )}

          {image && !hasLinkedImages && (
            <div className="quiz-image">
              <img src={image} alt="" />
            </div>
          )}

          <div className={`question-answer-wrapper ${columnDirection ? 'column-direction' : ''}`}>
            {hasLinkedImages && (
              <div className="quiz-images-grid">
                {images.map((img, index) => (
                  <div key={index} className={`quiz-image-item ${getImageState(index)}`}>
                    <img src={img.src} alt="" />
                  </div>
                ))}
              </div>
            )}

            <div className="quiz-options">
              {options.map((option, index) => {
                const isSelected = selectedOption?.index === index;
                let stateClass = '';
                if (isChecked && isSelected) {
                  stateClass = option.correct ? 'correct' : 'incorrect';
                } else if (isSelected) {
                  stateClass = 'selected';
                }
                return (
                  <button
                    key={index}
                    onClick={() => handleSelect(option, index)}
                    className={`quiz-option ${stateClass}`}
                    dangerouslySetInnerHTML={{ __html: option.text }}
                  />
                );
              })}
            </div>
          </div>

          {showFeedback && (
            <div
              className={`quiz-feedback ${feedbackClass}`}
              dangerouslySetInnerHTML={{ __html: feedbackContent }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
